import { NewChatOptionType } from "../types/types";
import { Strings } from "./strings";

export const NewChatOptions: NewChatOptionType[] = [
  { id: 1, label: Strings.BOOK_A_COURT },
  { id: 2, label: Strings.CANCEL_BOOKING },
  { id: 3, label: Strings.GET_COACH_INFO },
  { id: 4, label: Strings.IF_COURTS_PLAYABLE },
  { id: 5, label: Strings.FIND_NEXT_AVAILABLE_COURT },
  { id: 6, label: Strings.CHECK_IF_RAINING },
];
